module.exports = __webpack_public_path__ + "static/img/icon-no-lanes-bg.8ae7a52.svg";